import React from 'react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import { DropdownItem, Nav, NavItem, NavLink } from 'reactstrap' //Dropdown, DropdownToggle, DropdownMenu, DropdownItem,
import { OverlayTrigger, Tooltip } from 'react-bootstrap'

import Beta from '../widgets/Beta'
import EntitlementAccessHelper from '../../classes/EntitlementAccessHelper'
import DateHelpers from '../../classes/DateHelpers'
import { MEDIA_PREFERENCE, BRAND_PREFERENCE, DEMOGRAPHICS, TRENDING, ANTICIPATION, HOME_PAGE, ENTITY, VIDEO_CHANNEL, HOMEPAGE, LIBRARY, TRACKER, DISCOVER_EXPLORE, REDISCOVER, CALENDAR, ACTIVE, TRACKER_MODULE, AUDIENCE_ACQUISITION_MODULE, DISCOVER, SUBSCRIBER_OVERVIEW, SUBSCRIBER, ACQUISITION_ROLLING, ACQUISITION_PREMIERE, ATTENTION_INDEX, CONTENT_INTELLIGENCE, CATALOG_ANALYSIS, PERFORMANCE_ANALYSIS, AUDIENCE_LIFT_MODULE, ATTENTION_INDEX_MODULE, BUDGET_SUBSCRIBERS, BUDGET_SUBSCRIBERS_MODULE, DASHBOARD, MEDIA_PLANNING, CALENDAR_MODULE, MEDIA_PLANNING_SHORTCUT, GLOBAL_ATTENTION_INDEX, ATTENTION_INDEX_NEW, AI_INSIGHTS, CHAT_BOT } from '../../constants/commons'
import { CHAT_BOTS } from '../../constants/chat_bot'

import './SidebarComponent.scss'
import { withStyles } from '@material-ui/core/styles'

import { styles } from '../../classes/Styles'
import { LS_HOMEPAGE_KEY } from '../../constants/local_storage'
import { SOV_DISTRIBUTION, SOV_MEDIA_COMPANY, SOV_STREAMING, STREAMING } from '../../constants/sov'

class SidebarComponent extends React.Component {
  static propTypes = {
    isAdmin: PropTypes.bool.isRequired,
    profile: PropTypes.object,
    topic: PropTypes.object,
    topicId: PropTypes.string,
    logout: PropTypes.func.isRequired,
    location: PropTypes.object,
    homepage: PropTypes.object,
    shortcut: PropTypes.shape({
      id: PropTypes.string.isRequired,
      expires_at: PropTypes.string.isRequired,
      target: PropTypes.string.isRequired,
      target_id: PropTypes.string
    }),
    classes: PropTypes.object.isRequired,
    setShortcutPreference: PropTypes.func,
    shortcutPreference: PropTypes.string,
    selectedNav: PropTypes.string,
    isContentIntelligence: PropTypes.bool,
    isCatalogAnalysis: PropTypes.bool,
    isPerformanceAnalysis: PropTypes.bool,
    isAIInsights: PropTypes.bool,
    selectedSidebarNav: PropTypes.func
  }

  constructor (props) {
    super(props)
    this.state = {
      dropdownOpen: false,
      sideOpen: false,
      screenWidth: window.innerWidth,
      selectedNav: '',
      isContentIntelligence: true,
      isCatalogAnalysis: true,
      isPerformanceAnalysis: true,
      isAIInsights: true
    }
  }

  updateDimensions = () => {
    this.setState({ screenWidth: window.innerWidth })
  }

  componentDidMount () {
    window.addEventListener('resize', this.updateDimensions)
  }

  selectedNavBar = (nav) => {
    switch (nav) {
      case CONTENT_INTELLIGENCE:
        this.setState({ isContentIntelligence: !this.state.isContentIntelligence })
        break
      case CATALOG_ANALYSIS:
        this.setState({ isCatalogAnalysis: !this.state.isCatalogAnalysis })
        break
      case PERFORMANCE_ANALYSIS:
        this.setState({ isPerformanceAnalysis: !this.state.isPerformanceAnalysis })
        break
      case AI_INSIGHTS:
        this.setState({ isAIInsights: !this.state.isAIInsights })
        break
      default:
        break
    }
    this.props.selectedSidebarNav(nav)
  }

  render () {
    const { profile, classes, shortcut } = this.props
    const homepage = this.props.homepage && this.props.homepage.details ? this.props.homepage : JSON.parse(localStorage.getItem(LS_HOMEPAGE_KEY))
    const userGroups = profile && profile.groups
    let pathname = this.props.location ? this.props.location.pathname : ''
    const selectedModule = this.props.shortcut ?
    (this.props.shortcut.target === HOME_PAGE ? HOMEPAGE
      : this.props.shortcut.target === SUBSCRIBER ? SUBSCRIBER_OVERVIEW
      : this.props.shortcut.target === TRACKER_MODULE ? TRACKER
      : this.props.shortcut.target === AUDIENCE_ACQUISITION_MODULE ? ACQUISITION_ROLLING
      : this.props.shortcut.target === AUDIENCE_LIFT_MODULE ? ACQUISITION_PREMIERE
      : this.props.shortcut.target === DISCOVER ? DISCOVER
      : this.props.shortcut.target === ATTENTION_INDEX_MODULE ? ATTENTION_INDEX
      : this.props.shortcut.target === SOV_STREAMING ? DASHBOARD
      : this.props.shortcut.target === SOV_DISTRIBUTION ? DASHBOARD
      : this.props.shortcut.target === SOV_MEDIA_COMPANY ? DASHBOARD
      : this.props.shortcut.target === CALENDAR_MODULE ? CALENDAR
      : this.props.shortcut.target === MEDIA_PLANNING_SHORTCUT ? MEDIA_PLANNING
      : ((this.props.shortcut.target === ENTITY || this.props.shortcut.target === VIDEO_CHANNEL) ? this.props.shortcutPreference : EntitlementAccessHelper.getCurrentModule(pathname)))
    : EntitlementAccessHelper.getCurrentModule(pathname)

    const sideToggle = () => {
      this.setState({ sideOpen: !this.state.sideOpen })
    }
    const currentDateStr = DateHelpers.getDateString(new Date())
    const dashboardLink = this.props.shortcut ? '#' : `/insights/dashboard/${STREAMING}`
    const attentionLink = this.props.shortcut ? '#' : '/insights/attention'
    const calendarLink = this.props.shortcut ? '#' : `/insights/calendar/${currentDateStr}`
    const faqLink = '/insights/faq'
    const showAttentionIndex = homepage && homepage.details && homepage.details.is_attention_index ? true : false
    const globalAttentionLink = this.props.shortcut ? '#' : showAttentionIndex ? '/insights/attentionindex' : '#'
    const logo = this.state.screenWidth < 768 ? '/static/images/dlLogoMobile.svg' : '/static/images/dieselLogoWhite.svg'
    const networkId = homepage ? homepage.details.network_entities.filter(e => e.is_default) : []
    const networkEntityId = networkId.length > 0 ? networkId[0].audience_acquisition_entity_id : null
    const showDiscover = homepage && homepage.details && homepage.details.discover_entities && homepage.details.discover_entities.length > 0 ? true : false
    const showSubscirber = homepage && homepage.details && homepage.details.subscriber_networks && homepage.details.subscriber_networks.length > 0 ? true : false
    const showTracker = homepage && homepage.details && homepage.details.trackers.length > 0 ? true : false
    const showAudienceAcquisition = homepage && homepage.details && homepage.details.network_entities && homepage.details.network_entities.length > 0 ? true : false
    const showSOV = homepage && homepage.details && homepage.details.sov_networks && homepage.details.sov_networks.length > 0 ? true : false
    const showChatBot = homepage && homepage.details && homepage.details.chat_bots	 && homepage.details.chat_bots	.length > 0 ? true : false
    return (
      <>
        <div className={`${classes.topBar} mobileMenu`}>
          <div className={classes.topBarDiv}>
            <span className={classes.topBarLogo}><img src="/static/images/topBarLogo.svg" alt="topBarLogo" className={classes.topBarLogoImg}/></span>
            <span onClick={sideToggle} className={classes.topBarMenu}><img src="/static/images/topBarMenu.png" alt="topBarMenu"/></span>
          </div>
        </div>
        <div className={ this.state.sideOpen? 'sideOpen sideBar' : 'sideBar' }>
          <ul className="infoBlock">
            <li>
              <img src={logo} alt="logo" className="logo"/>
            </li>
          </ul>
          <DropdownItem divider />
          <nav>
            <Nav vertical className="leftNav">
              { ((!shortcut && showAttentionIndex) || (shortcut && (shortcut.target === ATTENTION_INDEX_NEW))) &&
                <NavItem className={selectedModule === GLOBAL_ATTENTION_INDEX ? ACTIVE : ''}>
                  <Link to={globalAttentionLink} className="home-page nav-link">
                    <img src={selectedModule === GLOBAL_ATTENTION_INDEX ? '/static/images/navAttentionIndex.svg' : '/static/images/navAttentionIndexWhite.svg'} alt="umap" className="umap navImg"/>
                    <span className='calendarNav'>Attention Index</span>
                  </Link>
                </NavItem>
              }
              { ((!shortcut && this.props.isAdmin) || (shortcut && (shortcut.target === ATTENTION_INDEX_MODULE))) &&
                <NavItem className={selectedModule === ATTENTION_INDEX ? ACTIVE : ''}>
                  <Link to={attentionLink} className="home-page nav-link">
                    <img src={selectedModule === ATTENTION_INDEX ? '/static/images/navAttentionIndex.svg' : '/static/images/navAttentionIndexWhite.svg'} alt="umap" className="umap navImg"/>
                    <span className='calendarNav'>Attention Index (v2)</span>
                  </Link>
                </NavItem>
              }
              { ((!shortcut && showSOV) || (shortcut && (shortcut.target === SOV_STREAMING || shortcut.target === SOV_DISTRIBUTION || shortcut.target === SOV_MEDIA_COMPANY))) &&
                <NavItem className={selectedModule === DASHBOARD ? ACTIVE : ''}>
                  <Link to={dashboardLink} className="home-page nav-link">
                    <img src={selectedModule === DASHBOARD ? '/static/images/sovBlack.svg' : '/static/images/sovWhite.svg'} alt="umap" className="umap navImg"/>
                    <span className='calendarNav'>Share of Conversation</span>
                  </Link>
                </NavItem>
              }
              { (!shortcut || (shortcut && (shortcut.target === CALENDAR_MODULE))) &&
                <NavItem className={selectedModule === CALENDAR ? ACTIVE : ''}>
                  <Link to={calendarLink} className="home-page nav-link">
                    <img src={selectedModule === CALENDAR ? '/static/images/navCalendar.svg' : '/static/images/navCalendarWhite.svg'} alt="umap" className="umap navImg"/>
                    <span className='calendarNav'>Calendar</span>
                  </Link>
                </NavItem>
              }
              { (!shortcut) &&
                <>
                  <DropdownItem divider />
                  <NavItem >
                    <NavLink onClick={() => this.selectedNavBar(CONTENT_INTELLIGENCE)} className="home-page nav-link navHeading">
                      <span>Content Intelligence</span>
                      <img src="/static/images/navArrowWhite.svg" alt="home" className={this.props.isContentIntelligence ? '' : 'navArrowActive'}/>
                    </NavLink>
                  </NavItem>
                </>
              }
              { this.props.isContentIntelligence &&
                <ContentIntelligenceSidebar
                  shortcut={this.props.shortcut}
                  shortcutPreference={this.props.shortcutPreference}
                  setShortcutPreference={this.props.setShortcutPreference}
                  selectedModule={selectedModule}
                  userGroups={userGroups}
                  topic={this.props.topic}
                  location={pathname}
                  homepage={homepage}
                  selectedNavBar={this.selectedNavBar}
                  isAdmin={this.props.isAdmin}
                />
              }
              { ((!shortcut && showSubscirber) || (!shortcut && showDiscover)) &&
                <>
                  <DropdownItem divider />
                  <NavItem >
                    <NavLink onClick={() => this.selectedNavBar(CATALOG_ANALYSIS)} className="home-page nav-link navHeading">
                      <span >Catalog Analysis</span>
                      <img src="/static/images/navArrowWhite.svg" alt="home" className={this.props.isCatalogAnalysis ? '' : 'navArrowActive'}/>
                    </NavLink>
                  </NavItem>
                </>
              }
              { this.props.isCatalogAnalysis &&
              <CatalogAnalysisSidebar
                shortcut={this.props.shortcut}
                shortcutPreference={this.props.shortcutPreference}
                setShortcutPreference={this.props.setShortcutPreference}
                selectedModule={selectedModule}
                userGroups={userGroups}
                homepage={homepage}
                isAdmin={this.props.isAdmin}
              />
              }
              { ((!shortcut && showTracker) || (!shortcut && showAudienceAcquisition)) &&
                <>
                  <DropdownItem divider />
                  <NavItem >
                    <NavLink onClick={() => this.selectedNavBar(PERFORMANCE_ANALYSIS)} className="home-page nav-link navHeading">
                      <span>Performance Analysis</span>
                      <img src="/static/images/navArrowWhite.svg" alt="home" className={this.props.isPerformanceAnalysis ? '' : 'navArrowActive'}/>
                    </NavLink>
                  </NavItem>
                </>
              }
              { this.props.isPerformanceAnalysis &&
              <PerformanceAnalysisSidebar
                shortcut={this.props.shortcut}
                shortcutPreference={this.props.shortcutPreference}
                setShortcutPreference={this.props.setShortcutPreference}
                selectedModule={selectedModule}
                userGroups={userGroups}
                homepage={homepage}
                topicId={this.props.topicId ? this.props.topicId : networkEntityId}
              />
              }
              { ((!shortcut && showChatBot)|| (shortcut && ((CHAT_BOTS.filter(e => e.botValue === shortcut.target).length > 0)))) &&
                <>
                  { (!shortcut && showChatBot) &&
                    <DropdownItem divider />
                  }
                  <NavItem >
                    <NavLink onClick={() => this.selectedNavBar(AI_INSIGHTS)} className="home-page nav-link navHeading">
                      <span>AI Insights</span>
                      <img src="/static/images/navArrowWhite.svg" alt="home" className={this.props.isAIInsights ? '' : 'navArrowActive'}/>
                    </NavLink>
                  </NavItem>
                </>
              }
              { ((!shortcut && showChatBot && this.props.isAIInsights) || (this.props.isAIInsights && shortcut && (CHAT_BOTS.filter(e => e.botValue === shortcut.target).length > 0))) &&
                <AIInsightsSidebar
                  shortcut={this.props.shortcut}
                  shortcutPreference={this.props.shortcutPreference}
                  setShortcutPreference={this.props.setShortcutPreference}
                  selectedModule={selectedModule}
                  userGroups={userGroups}
                  homepage={homepage}
                />
              }
            </Nav>
            <Nav className={!this.props.shortcut ? 'footerLogoutFaqInfo' : 'footerFaqInfo'}>
              {!this.props.shortcut &&
              <NavItem>
                <NavLink onClick={this.props.logout}>
                  <span className='logoutSpan'>Logout</span>
                </NavLink>
              </NavItem>
              }
              <NavItem>
                <Link to={faqLink} target="_blank">
                  <span className='faqSpan'>FAQs</span>
                </Link>
              </NavItem>
            </Nav>
            <Nav className="footerInfo">
              <NavItem>
                <NavLink href="https://www.diesellabs.com/privacy/" target="_blank" rel="noopener noreferrer">Privacy Policy</NavLink>
              </NavItem>
              <NavItem>
                <NavLink href="https://www.diesellabs.com/terms-of-service/" target="_blank" rel="noopener noreferrer">Terms of Service</NavLink>
              </NavItem>
            </Nav>
          </nav>
        </div>
      </>
    )
  }
}

const ContentIntelligenceSidebar = ({ topic, location, shortcut, homepage, selectedModule, shortcutPreference, setShortcutPreference, userGroups, isAdmin }) => {
  const homePageLink = shortcut ? '#' : '/insights/homepage'
  const libraryLink = shortcut ? '#' : '/insights/library'
  const showHomepage = homepage && homepage.details && homepage.details.homepage_entities && homepage.details.homepage_entities.length > 0 ? true : false
  return (
    <NavItem>
      <Nav vertical className="levelOne">
        { ((!shortcut && showHomepage) || (shortcut && shortcut.target === HOME_PAGE)) &&
          <NavItem className={selectedModule === HOMEPAGE ? ACTIVE : ''}>
            <Link to={homePageLink} className="home-page nav-link">
              <img src={selectedModule === HOMEPAGE ? '/static/images/navNetworkPlatform.svg' : '/static/images/navNetworkPlatformWhite.svg'} alt="home" className="home navImg"/>
              <span className='calendarNav'>Networks & Platforms</span>
            </Link>
          </NavItem>
        }
        { (!shortcut || (shortcut && (shortcut.target === ENTITY || shortcut.target === VIDEO_CHANNEL || shortcut.target === MEDIA_PLANNING_SHORTCUT))) &&
          <NavItem className={selectedModule === LIBRARY ? ACTIVE : ''}>
            <Link to={libraryLink} className="home-page nav-link">
              <img src={selectedModule === LIBRARY ? '/static/images/navLibrary.svg' : '/static/images/navLibraryWhite.svg'} alt="library" className="library navImg"/>
              <span className='calendarNav'>Library</span>
            </Link>
          </NavItem>
        }
        <AudienceSidebar
          topic={topic}
          location={location}
          selectedModule={selectedModule}
          userGroups={userGroups}
          shortcut={shortcut}
          shortcutPreference={shortcutPreference}
          setShortcutPreference={setShortcutPreference}
          isAdmin={isAdmin}
        />
      </Nav>
    </NavItem>
  )
}

ContentIntelligenceSidebar.propTypes = {
  topic: PropTypes.object,
  location: PropTypes.string.isRequired,
  selectedModule: PropTypes.string.isRequired,
  userGroups: PropTypes.array,
  shortcut: PropTypes.shape({
    id: PropTypes.string.isRequired,
    expires_at: PropTypes.string.isRequired,
    target: PropTypes.string.isRequired,
    target_id: PropTypes.string
  }),
  homepage: PropTypes.object,
  shortcutPreference: PropTypes.string,
  setShortcutPreference: PropTypes.func,
  selectedNavBar: PropTypes.func,
  isAdmin: PropTypes.bool.isRequired
}

const CatalogAnalysisSidebar = ({ shortcut, homepage, selectedModule, shortcutPreference, setShortcutPreference, isAdmin }) => {
  const showDiscover = homepage && homepage.details && homepage.details.discover_entities && homepage.details.discover_entities.length > 0 ? true : false
  const showSubscirber = homepage && homepage.details && homepage.details.subscriber_networks && homepage.details.subscriber_networks.length > 0 ? true : false
  const showBudgetSubscirbers = homepage && homepage.details && homepage.details.is_budget_subscribers ? true : false
  const subscriberId = showSubscirber && homepage.details.subscriber_networks[0].subscriber_id
  const subscriberLink = shortcut ? '#' : showSubscirber ? `/insights/subscriber/${subscriberId}` : '#'
  const budgetSubscribersLink = shortcut ? '#' : showBudgetSubscirbers ? '/insights/budget' : '#'
  const uMapLink = shortcut ? '#' : '/insights/discover'
  return (
    <NavItem>
      <Nav vertical className="levelOne">
        { ((!shortcut && showSubscirber)
          || (shortcut && shortcut.target === SUBSCRIBER)) &&
          <NavItem className={selectedModule === SUBSCRIBER_OVERVIEW ? ACTIVE : ''}>
            <Link to={subscriberLink} className="home-page nav-link subscriber-menu" title="Catalog Overview">
              <img src={selectedModule === SUBSCRIBER_OVERVIEW ? '/static/images/navCompare.svg' : '/static/images/navCompareWhite.svg'} alt="subscriber" className="subscriber navImg"/>
              <span className='calendarNav'>Catalog Overview</span>
            </Link>
          </NavItem>
        }
        { ((!shortcut && showBudgetSubscirbers)
          || (shortcut && shortcut.target === BUDGET_SUBSCRIBERS_MODULE)) && //
          <NavItem className={selectedModule === BUDGET_SUBSCRIBERS ? ACTIVE : ''}>
            <Link to={budgetSubscribersLink} className="home-page nav-link subscriber-menu" title="Budget & Subscribers">
              <img src={selectedModule === BUDGET_SUBSCRIBERS ? '/static/images/budget-active.svg' : '/static/images/budget-default.svg'} alt="subscriber" className="subscriber navImg"/>
              <span className='calendarNav'>Budget & Subscribers</span>
            </Link>
          </NavItem>
        }
        { ((!shortcut && isAdmin) || (!shortcut && showDiscover) || (shortcut && shortcut.target === DISCOVER)) &&
          <NavItem >
            <Link to={uMapLink} className="home-page nav-link">
              <img src="/static/images/navDiscoverWhite.svg" alt="umap" className="umap navImg"/>
              <span className='calendarNav'>Discover<Beta color='#BDBDBD'/></span>
            </Link>
          </NavItem>
        }
        {((!shortcut && (selectedModule === REDISCOVER || selectedModule === DISCOVER_EXPLORE)) || (shortcut && shortcut.target === DISCOVER)) &&
          <DiscoverSidebar
            shortcut={shortcut}
            shortcutPreference={shortcutPreference}
            setShortcutPreference={setShortcutPreference}
            selectedModule={selectedModule} />
        }
      </Nav>
    </NavItem>
  )
}

CatalogAnalysisSidebar.propTypes = {
  selectedModule: PropTypes.string.isRequired,
  shortcut: PropTypes.shape({
    id: PropTypes.string.isRequired,
    expires_at: PropTypes.string.isRequired,
    target: PropTypes.string.isRequired,
    target_id: PropTypes.string
  }),
  homepage: PropTypes.object,
  isAdmin: PropTypes.bool,
  shortcutPreference: PropTypes.string,
  setShortcutPreference: PropTypes.func
}

const PerformanceAnalysisSidebar = ({ shortcut, homepage, selectedModule, shortcutPreference, setShortcutPreference, topicId }) => {
  const showTracker = homepage && homepage.details && homepage.details.trackers.length > 0 ? true : false
  const showAudienceAcquisition = homepage && homepage.details && homepage.details.network_entities && homepage.details.network_entities.length > 0 ? true : false
  const trackerLink = shortcut ? '#' : '/insights/tracker'
  return (
    <NavItem>
      <Nav vertical className="levelOne">
        { ((!shortcut && showTracker)
          || (shortcut && shortcut.target === TRACKER_MODULE)) &&
          <NavItem className={selectedModule === TRACKER ? ACTIVE : ''}>
            <Link to={trackerLink} className="home-page nav-link">
              <img src={selectedModule === TRACKER ? '/static/images/navAttentionTracker.svg' : '/static/images/navAttentionTrackerWhite.svg'} alt="tracker" className="tracker navImg"/>
              <span className='calendarNav'>Attention Tracker</span>
            </Link>
          </NavItem>
        }
        { ((!shortcut && showAudienceAcquisition) || (shortcut && shortcut.target === AUDIENCE_ACQUISITION_MODULE) || (shortcut && shortcut.target === AUDIENCE_LIFT_MODULE)) &&
          <AudienceAcquisitionSidebar
            topicId={topicId}
            homepage={homepage}
            shortcut={shortcut}
            shortcutPreference={shortcutPreference}
            setShortcutPreference={setShortcutPreference}
            selectedModule={selectedModule} />
        }
      </Nav>
    </NavItem>
  )
}

PerformanceAnalysisSidebar.propTypes = {
  selectedModule: PropTypes.string.isRequired,
  shortcut: PropTypes.shape({
    id: PropTypes.string.isRequired,
    expires_at: PropTypes.string.isRequired,
    target: PropTypes.string.isRequired,
    target_id: PropTypes.string
  }),
  homepage: PropTypes.object,
  topicId: PropTypes.string,
  shortcutPreference: PropTypes.string,
  setShortcutPreference: PropTypes.func
}

const AIInsightsSidebar = ({ shortcut, selectedModule, shortcutPreference }) => {
  const chatBotLink = shortcut ? '#' : '/insights/chatbot'
  return (
    <NavItem>
      <Nav vertical className="levelOne">
        <NavItem>
          {
            <div id='rollingNav'>
              <Link to={chatBotLink} className={selectedModule === CHAT_BOT || shortcutPreference === CHAT_BOT ? ACTIVE : ''}>
                <img src={selectedModule === CHAT_BOT || shortcutPreference === CHAT_BOT ? '/static/images/navNewAudience.svg' : '/static/images/navNewAudienceWhite.svg'} alt="chatbot" className="audience"/>
                <span className='calendarNav'>Chat with Daisy</span>
              </Link>
            </div>
          }
        </NavItem>
      </Nav>
    </NavItem>
  )
}

AIInsightsSidebar.propTypes = {
  selectedModule: PropTypes.string.isRequired,
  shortcut: PropTypes.shape({
    id: PropTypes.string.isRequired,
    expires_at: PropTypes.string.isRequired,
    target: PropTypes.string.isRequired,
    target_id: PropTypes.string
  }),
  homepage: PropTypes.object,
  shortcutPreference: PropTypes.string,
  setShortcutPreference: PropTypes.func
}

const DiscoverSidebar = ({ shortcut, selectedModule, shortcutPreference }) => {
  const uMapLink = shortcut ? '#' : '/insights/discover'
  const reDiscoverLink = shortcut ? '#' : '/insights/rediscover'
  const uMapSelected = (shortcut && shortcut.target === DISCOVER && shortcutPreference === DISCOVER_EXPLORE) || (shortcut && !shortcut.target_id && (shortcutPreference === DISCOVER_EXPLORE || shortcutPreference !== REDISCOVER))
  const rediscoverSelected = shortcut && shortcut.target_id && shortcut.target === DISCOVER && (shortcutPreference === REDISCOVER || shortcutPreference !== DISCOVER_EXPLORE)
  return (
    <NavItem>
      <Nav vertical className="levelOne">
        <NavItem>
          <div id='discoverNav'>
            <Link to={uMapLink} className={selectedModule === DISCOVER_EXPLORE || uMapSelected ? ACTIVE : ''}>
              <span className='discoverNav'>Explore</span>
            </Link>
          </div>
          <div id='rediscoverNav'>
            <Link to={reDiscoverLink} className={selectedModule === REDISCOVER || rediscoverSelected ? ACTIVE : ''}>
              <span className='discoverNav'>Content Analysis</span>
            </Link>
          </div>
        </NavItem>
      </Nav>
    </NavItem>
  )
}

DiscoverSidebar.propTypes = {
  shortcut: PropTypes.shape({
    id: PropTypes.string.isRequired,
    expires_at: PropTypes.string.isRequired,
    target: PropTypes.string.isRequired,
    target_id: PropTypes.string
  }),
  selectedModule: PropTypes.string.isRequired,
  shortcutPreference: PropTypes.string,
  setShortcutPreference: PropTypes.func
}

const AudienceSidebar = ({ topic, location, selectedModule, shortcut, shortcutPreference, setShortcutPreference, isAdmin }) => {
  const topicId =
    shortcut ? shortcut.target_id : selectedModule === MEDIA_PREFERENCE ?
    location.substring(location.indexOf('audience/')+9, location.indexOf('/media')) :
    selectedModule === BRAND_PREFERENCE ?
    location.substring(location.indexOf('audience/')+9, location.indexOf('/brand')) :
    selectedModule === DEMOGRAPHICS ?
    location.substring(location.indexOf('audience/')+9, location.indexOf('/demographics')) :
    selectedModule === TRENDING ?
    location.substring(location.indexOf('audience/')+9, location.indexOf('/trending')) :
    selectedModule === ANTICIPATION ?
    location.substring(location.indexOf('audience/')+9, location.indexOf('/anticipation')) :
    selectedModule === MEDIA_PLANNING ?
    location.substring(location.indexOf('audience/')+9, location.indexOf('/plan')) : null

  let name = null

  if (topicId && topic && topic[topicId] && topic[topicId].details && topic[topicId].details.details) {
    const details = topic[topicId].details.details
    const entityLocalization = (details && details.entity_localization_override&& details.entity_localization_override.length > 0) && details.entity_localization_override[0]
    name = entityLocalization && entityLocalization.display_name ? entityLocalization.display_name : details.display_name || details.name
  }

  if (!name) {
    return null
  }

  const nameWithTooltip = (name) => {
    const strLimit = 35
    let limit = strLimit
    const strArr = name.split(' ')
    if (strArr.length >= 5) {
      limit = (name.length > strLimit && strArr.length <= 5) ? name.indexOf(strArr[4]) : name.indexOf(strArr[5])
    }
    if (name.length > strLimit || strArr.length > 5) {
      const tooltip = <Tooltip id="tooltip">{name}</Tooltip>
      return (
        <OverlayTrigger overlay={tooltip} placement='bottom'>
          <span className="txt">{name.substring(0, limit)}...</span>
        </OverlayTrigger>
      )
    }
    return (<span>{name}</span>)
  }

  const media_link = shortcut ?'#':`/insights/audience/${topicId}/${MEDIA_PREFERENCE}`
  const brand_link = shortcut ? '#':`/insights/audience/${topicId}/${BRAND_PREFERENCE}`
  const demo_graphic_link = shortcut ? '#' : `/insights/audience/${topicId}/${DEMOGRAPHICS}`
  const anticipation_link = shortcut ? '#' : `/insights/audience/${topicId}/${ANTICIPATION}`
  const media_planning_link = shortcut ? '#' : `/insights/audience/${topicId}/${MEDIA_PLANNING}`

  const setPreference = (type) => {
    if (shortcut) {
      setShortcutPreference(type)
    }
  }
  return (
    <NavItem>
      <NavLink className="selected-audience">
        <img src="/static/images/navAudienceTitleWhite.svg" alt="audience" className="audience"/>
        <span>
          <div>{nameWithTooltip(name)}</div>
        </span>
      </NavLink>
      <Nav vertical className="levelOne audiencePrefLevelOne">
        <NavItem>
          {((shortcut && shortcut.target !== MEDIA_PLANNING_SHORTCUT) || !shortcut) &&
            <div>
              <Link to={media_link} onClick={() => setPreference(MEDIA_PREFERENCE)} className={selectedModule === MEDIA_PREFERENCE || shortcutPreference === MEDIA_PREFERENCE ? ACTIVE + ' audiencePref' : 'audiencePref'}>
                <img src={selectedModule === MEDIA_PREFERENCE || shortcutPreference === MEDIA_PREFERENCE ? '/static/images/navMediaPref.svg' : '/static/images/navMediaPrefWhite.svg'} alt="audience" className="audience navImg"/>
                <span className='calendarNav'>Media Habits</span>
              </Link>
              <div id='brandDemo'>
                <Link to={brand_link} onClick={() => setPreference(BRAND_PREFERENCE)} className={selectedModule === BRAND_PREFERENCE || shortcutPreference === BRAND_PREFERENCE ? ACTIVE + ' audiencePref' : 'audiencePref'}>
                  <img src={selectedModule === BRAND_PREFERENCE || shortcutPreference === BRAND_PREFERENCE ? '/static/images/navBrandPref.svg' : '/static/images/navBrandPrefWhite.svg'} alt="audience" className="audience navImg"/>
                  <span className='calendarNav'>Brands & Ad Sales</span>
                </Link>
                <Link to={demo_graphic_link} onClick={() => setPreference(DEMOGRAPHICS)} className={selectedModule === DEMOGRAPHICS || shortcutPreference === DEMOGRAPHICS ? ACTIVE + ' audiencePref' : 'audiencePref'}>
                  <img src={selectedModule === DEMOGRAPHICS || shortcutPreference === DEMOGRAPHICS ? '/static/images/navDemoPref.svg' : '/static/images/navDemoPrefWhite.svg'} alt="audience" className="audience navImg"/>
                  <span className='calendarNav'>Demographics</span>
                </Link>
              </div>
              <div id='trendingAnticipation'>
                <Link to={anticipation_link} onClick={() => setPreference(ANTICIPATION)} className={selectedModule === ANTICIPATION || shortcutPreference === ANTICIPATION ? ACTIVE + ' audiencePref' : 'audiencePref'}>
                  <img src={selectedModule === ANTICIPATION || shortcutPreference === ANTICIPATION ? '/static/images/navAnticipationPref.svg' : '/static/images/navAnticipationPrefWhite.svg'} alt="audience" className="audience navImg"/>
                  <span className='calendarNav'>Anticipation</span>
                </Link>
              </div>
            </div>
           }
          { ((isAdmin && !shortcut) || (shortcut && shortcut.target === MEDIA_PLANNING_SHORTCUT)) &&
            <Link to={media_planning_link} onClick={() => setPreference(MEDIA_PLANNING)} className={selectedModule === MEDIA_PLANNING || shortcutPreference === MEDIA_PLANNING ? ACTIVE + ' audiencePref' : 'audiencePref'}>
              <img src={selectedModule === MEDIA_PLANNING || shortcutPreference === MEDIA_PLANNING ? '/static/images/navMediaPlanning.svg' : '/static/images/navMediaPlanningWhite.svg'} alt="audience" className="audience navImg"/>
              <span className='calendarNav'>Media Planning<Beta color='#BDBDBD'/></span>
            </Link>
          }
        </NavItem>
      </Nav>
    </NavItem>
  )
}

AudienceSidebar.propTypes = {
  topic: PropTypes.object,
  location: PropTypes.string.isRequired,
  selectedModule: PropTypes.string.isRequired,
  userGroups: PropTypes.array,
  shortcut: PropTypes.shape({
    id: PropTypes.string.isRequired,
    expires_at: PropTypes.string.isRequired,
    target: PropTypes.string.isRequired,
    target_id: PropTypes.string
  }),
  shortcutPreference: PropTypes.string,
  setShortcutPreference: PropTypes.func,
  isAdmin: PropTypes.bool.isRequired
}

const AudienceAcquisitionSidebar = ({ homepage, shortcut, selectedModule, shortcutPreference, setShortcutPreference }) => {
  const audienceLink = shortcut ? '#' : '/insights/acquisition'
  let premiereLink = shortcut ? '#' : ''
  if (!shortcut && homepage.details && homepage.details.network_entities && homepage.details.network_entities.length > 0) {
    const networkId = homepage.details.network_entities.filter(e => e.is_default)
    const networkEntityId = networkId.length > 0 && networkId[0].audience_acquisition_entity_id
    if (networkEntityId) {
      premiereLink = shortcut ? '#' : `/insights/acquisition/${networkEntityId}/${ACQUISITION_PREMIERE}`
    }
  }
  const setPreference = (type) => {
    if (shortcut) {
      setShortcutPreference(type)
    }
  }
  return (
    <NavItem>
      <Nav vertical className="levelOne">
        <NavItem>
          { ((!shortcut) || (shortcut && shortcut.target === AUDIENCE_ACQUISITION_MODULE)) &&
            <div id='rollingNav'>
              <Link to={audienceLink} onClick={() => setPreference(ACQUISITION_ROLLING)} className={selectedModule === ACQUISITION_ROLLING || shortcutPreference === ACQUISITION_ROLLING || shortcutPreference === MEDIA_PREFERENCE ? ACTIVE : ''}>
                <img src={selectedModule === ACQUISITION_ROLLING || shortcutPreference === ACQUISITION_ROLLING || shortcutPreference === MEDIA_PREFERENCE ? '/static/images/navNewAudience.svg' : '/static/images/navNewAudienceWhite.svg'} alt="audience" className="audience"/>
                <span className='calendarNav'>New Audience Drivers</span>
              </Link>
            </div>
          }
          { ((!shortcut) || (shortcut && shortcut.target === AUDIENCE_LIFT_MODULE)) &&
            <div id='premiereNav'>
              <Link to={premiereLink} onClick={() => setPreference(ACQUISITION_PREMIERE)} className={selectedModule === ACQUISITION_PREMIERE || shortcutPreference === ACQUISITION_PREMIERE ? ACTIVE : ''}>
                <img src={selectedModule === ACQUISITION_PREMIERE || shortcutPreference === ACQUISITION_PREMIERE ? '/static/images/navAudienceLift.svg' : '/static/images/navAudienceLiftWhite.svg'} alt="audience" className="audience"/>
                <span className='calendarNav'>Audience Lift<Beta color='#BDBDBD'/></span>
              </Link>
            </div>
          }
        </NavItem>
      </Nav>
    </NavItem>
  )
}

AudienceAcquisitionSidebar.propTypes = {
  topicId: PropTypes.string,
  homepage: PropTypes.object,
  shortcut: PropTypes.shape({
    id: PropTypes.string.isRequired,
    expires_at: PropTypes.string.isRequired,
    target: PropTypes.string.isRequired,
    target_id: PropTypes.string
  }),
  selectedModule: PropTypes.string.isRequired,
  shortcutPreference: PropTypes.string,
  setShortcutPreference: PropTypes.func
}

export default withStyles(styles)(SidebarComponent)